import React from 'react';
import UTMap from '../../UTMap';

import styles from './locationCard.scss';

const LocationCard = (props) => {
    const { location, 'data-testid': dataTestId } = props;
    const joinedLocation = location ? `${location.placeName ? `${location.placeName} ` : ''}${location.streetAddress ? `${location.streetAddress} ` : ''}${location.display ? location.display : ''}` : '';
    const directionsUrl = location ? `https://www.google.com/maps/dir//${joinedLocation.split(' ').join('+')}/@${location.latLng[0]},${location.latLng[1]}` : ``;

    return (
        <div className={`${styles.locationCard}`}>
            {location && (
                <div>
                    <h6 data-testid={dataTestId && `${dataTestId}.title`}>{props.title}</h6>
                    <div className={`${styles.locationWrapper}`}>
                        <div className={`${styles.locationDetails}`}>
                            <div className={`${styles.iconWrapper}`}>
                                <i className="uts uts-location" />
                                <p className={`${styles.locationName}`} data-testid={dataTestId && `${dataTestId}.location-name`}>
                                    <span className={`text-medium d-block d-md-none`} data-testid={dataTestId && `${dataTestId}.short-name`}>
                                        {`${props.shortName || props.name}`}
                                    </span>
                                    <span className={`text-medium d-none d-md-block`} data-testid={dataTestId && `${dataTestId}.full-name`}>
                                        {`${props.name}`}
                                    </span>
                                    {location.placeName && (
                                        <br />
                                    )}
                                    {location.placeName ? location.placeName : ''}
                                    {location.streetAddress && (
                                        <br />
                                    )}
                                    {location.streetAddress ? location.streetAddress : ''}
                                    {location.cityStateZip && (
                                        <br />
                                    )}
                                    {location.cityStateZip ? location.cityStateZip : ''}
                                </p>
                            </div>
                            <hr className="div" />
                            <div className="row">
                                <div className="col-md-6">
                                    <a className={`${styles.action}`} href={directionsUrl} target="_blank" rel="noopener noreferrer" data-testid={dataTestId && `${dataTestId}.directions-link`}>
                                        <i className={`${styles.actionIcon} uts uts-directions`} />
                                        <span className={`${styles.actionName}`} data-testid={dataTestId && `${dataTestId}.directions-label`}>Get directions</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="map">
                            <UTMap
                                lat={location.latLng[0]}
                                lng={location.latLng[1]}
                                placeId={location.googlePlaceId}
                                placeName={location.googleFormattedName}
                                height="216px"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

LocationCard.defaultProps = {
    'data-testid': null,
};

export default LocationCard;
